<template>
	<div class="text-center">
		<h2>
			Je partage sur les réseaux sociaux
		</h2>


		<div class="flex flex-center">
			<div class="share-item"><a target="_blank" href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fwww.greenpeace.fr%2Fpreuve-deforestation"><q-icon class="icon-facebook"/></a></div>
			<div class="share-item"><a target="_blank" href="https://api.whatsapp.com/send?text=Hello%20!%20Je%20suis%20s%C3%BBr%20que%20tu%20as%20entendu%20parler%20des%20feux%20de%20for%C3%AAt%20en%20Amazonie%20cet%20%C3%A9t%C3%A9.%20Notre%20pays%20a%20une%20part%20de%20complicit%C3%A9%20dans%20cette%20catastrophe%2C%20c%27est%20notre%20pr%C3%A9sident%20qui%20l%27a%20dit.%20Un%20nouveau%20cargo%20charg%C3%A9%20de%20soja%20br%C3%A9silien%20cultiv%C3%A9%20dans%20une%20zone%20ravag%C3%A9e%20par%20l%27agriculture%20industrielle%20est%20arriv%C3%A9%20en%20France%20ce%20jeudi.%20Il%20faut%20que%20%C3%A7a%20s%27arr%C3%AAte%20!%20Agis%20avec%20moi%20pour%20que%20ces%20importations%20cessent.%20RDV%20sur%20https%3A%2F%2Fwww.greenpeace.fr%2Fpreuve-deforestation"><q-icon class="icon-whatsapp"/></a></div>
			<div class="share-item"><a target="_blank" href="https://twitter.com/intent/tweet?text=Un%20nouveau%20cargo%20charg%C3%A9%20de%2060000%20t%20de%20soja%20%F0%9F%87%A7%F0%9F%87%B7%20venant%20d%27une%20zone%20d%C3%A9forest%C3%A9e%20arrive%20en%20France%20pour%20alimenter%20l%27%C3%A9levage%20industriel.%20%40Elisabeth_Borne%20%40dguillaume26%2C%20la%20France%20est%20complice%20de%20la%20d%C3%A9forestation.%20Assez%20!%20%23LaFranceComplice%20%23AlerteDeforestation&url=https%3A%2F%2Fwww.greenpeace.fr%2Fpreuve-deforestation"><q-icon class="icon-twitter"/></a></div>
		</div>

	</div>
</template>

<script>
export default {
	name: "ShareItems"
}
</script>

<style lang="stylus" scoped>
@import '~quasar-variables'

.share-item
	font-size 3rem
	cursor pointer
	padding: 1rem .5rem;
	a
		color $gris

</style>